import { Injectable, Injector } from '@angular/core';
import { CommandManagerService } from '@core/services/commands/command-manager.service';
import { CommandType } from '@core/services/commands/command-manager.types';
import { ActionSheetController } from '@ionic/angular';
import { BaseProductCommand } from '@shared/commands/base-product.command';
import { IProductCommandContext } from '@shared/models/command';
import { ProductTypes } from '@shared/models/products.model';
import { CommandAvailabilityService } from '@shared/services/command-availability.service';

@Injectable({ providedIn: 'root' })
export class CardGroupCommand extends BaseProductCommand {
  readonly type = 'group-actions';
  readonly title = 'Выпустить дополнительную карту';
  readonly icon = 'double-card';
  readonly productType = ProductTypes.CARD;
  readonly isInfoAction = false;
  readonly settingsNames = undefined;
  readonly order = 10;

  // Команды, которые группируются под этой
  readonly subCommands = ['additional', 'virtual'];

  constructor(
    commandAvailabilityService: CommandAvailabilityService,
    private actionSheetCtrl: ActionSheetController,
    private injector: Injector
  ) {
    super(commandAvailabilityService);
  }

  async execute(context: IProductCommandContext): Promise<void> {
    // Ленивое получение CommandManagerService для избежания циклической зависимости
    const commandManagerService = this.injector.get(CommandManagerService);

    // Получаем только нужные подкоманды
    commandManagerService.getCommands(CommandType.PRODUCT, context, true).subscribe(async (allCommands) => {
      // Фильтруем только подкоманды, которые нужны для этой группы
      const subCommands = allCommands.filter(cmd => this.subCommands.includes(cmd.type));

      if (subCommands.length === 0) {
        return; // Нет доступных подкоманд
      }

      // Создаем кнопки для ActionSheet
      const buttons = subCommands.map((command) => ({
        text: (command as BaseProductCommand).title || command.type,
        handler: () => {
          command.execute(context);

          return true;
        }
      }));

      buttons.push({
        text: 'Отмена',
        handler: () => true
      });

      const actionSheet = await this.actionSheetCtrl.create({
        header: this.title,
        buttons,
        mode: 'ios'
      });

      await actionSheet.present();
    });
  }

  protected checkAdditionalAvailability(context: IProductCommandContext): boolean {
    return !context.data.isVirtual;
  }
}
